import Api from './api';

const requestAuctionsList = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/inland/auctions', {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}

const requestPortsList = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/inland/ports', {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}

const requestPrice = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/inland/price', {
        headers: { Authorization: 'Bearer ' + access_token },
        params: query
    })
}

const requestClosestPort = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/inland/closest', {
        headers: { Authorization: 'Bearer ' + access_token },
        params: query
    })
}

const requestAuctionDeliveryPrices = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/inland/auction', {
        headers: { Authorization: 'Bearer ' + access_token },
        params: query
    })
}

export default {
    requestAuctionsList,
    requestPortsList,
    requestPrice,
    requestClosestPort,
    requestAuctionDeliveryPrices
}



// WEBPACK FOOTER //
// ./src/api/apiInlandPrice.js